import type { AttestMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { AttestDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * Maps the tRPC mutation response to match the GraphQL mutation
 * response shape so consumers branching on the result do not need
 * to know which path executed.
 */
const mapTrpcResponseToGraphQL = (data: {
  affected_rows: number;
}): AttestMutation => ({
  attestRecord: {
    __typename: 'GenericMutationOutput',
    affected_rows: data.affected_rows,
  },
});

export const useAttestRecord = createMutationHook({
  name: 'attest',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.attestation.attest.mutationOptions({ onSuccess }),
  mapInput: (input: { Id: string }) => ({ Id: input.Id }),
  mapResponse: (result: { affected_rows: number }) =>
    mapTrpcResponseToGraphQL(result),
  invalidate: (trpc) => [trpc.frontend.attestation.status.queryKey()],
  graphqlDocument: AttestDocument,
  graphqlVariables: (input: { Id: string }) => ({ Id: input.Id }),
});
